<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 flex items-center justify-center z-50">
      <!-- Fondo oscuro detrás -->
      <div class="fixed inset-0 bg-black bg-opacity-50" @click="closeOnOverlayClick"></div>

      <!-- Alerta -->
      <div
        :class="alertClasses"
        role="alert"
        class="relative flex items-center p-4 text-base rounded-lg shadow-lg w-full max-w-md z-10"
      >
        <font-awesome-icon :icon="icon" :class="['mr-4', iconColor, 'text-3xl']" />

        <div class="flex-1">
          <p class="font-semibold">{{ title }}</p>
          <p>{{ message }}</p>
        </div>
        <button
          v-if="dismissible"
          @click="closeAlert"
          class="ml-4 text-lg font-bold hover:opacity-75"
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BaseAlert",
  props: {
    type: {
      type: String,
      default: "success",
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 3000,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    closeOnBackdrop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    icon() {
      const icons = {
        success: ["fas", "check-circle"],
        error: ["fas", "times-circle"],
        warning: ["fas", "exclamation-triangle"],
        info: ["fas", "info-circle"],
      };
      return icons[this.type] || icons.info;
    },
    iconColor() {
      const colors = {
        success: "text-green-600",
        error: "text-red-600",
        warning: "text-yellow-600",
        info: "text-blue-600",
      };
      return colors[this.type] || colors.info;
    },
    alertClasses() {
      return {
        "bg-green-100 text-green-800 border border-green-300": this.type === "success",
        "bg-red-100 text-red-800 border border-red-300": this.type === "error",
        "bg-yellow-100 text-yellow-800 border border-yellow-300": this.type === "warning",
        "bg-blue-100 text-blue-800 border border-blue-300": this.type === "info",
      };
    },
  },
  mounted() {
    if (this.autoClose) {
      setTimeout(() => {
        this.closeAlert();
      }, this.duration);
    }
  },
  methods: {
    closeAlert() {
      this.visible = false;
      this.$emit("closed");
    },
    closeOnOverlayClick() {
      if (this.closeOnBackdrop) {
        this.closeAlert();
      }
    },
  },
};
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
